/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputPilotTeamSettings
 */
export interface OutputPilotTeamSettings {
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputPilotTeamSettings
     */
    craftNames: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof OutputPilotTeamSettings
     */
    allowBomberMissions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OutputPilotTeamSettings
     */
    allowOpticMissions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OutputPilotTeamSettings
     */
    allowRadioMissions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputPilotTeamSettings
     */
    droneUid: string;
    /**
     * 
     * @type {number}
     * @memberof OutputPilotTeamSettings
     */
    packetRate?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputPilotTeamSettings
     */
    preferredChannels: Array<string>;
}

/**
 * Check if a given object implements the OutputPilotTeamSettings interface.
 */
export function instanceOfOutputPilotTeamSettings(value: object): boolean {
    if (!('craftNames' in value)) return false;
    if (!('droneUid' in value)) return false;
    if (!('preferredChannels' in value)) return false;
    return true;
}

export function OutputPilotTeamSettingsFromJSON(json: any): OutputPilotTeamSettings {
    return OutputPilotTeamSettingsFromJSONTyped(json, false);
}

export function OutputPilotTeamSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputPilotTeamSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'craftNames': json['CraftNames'],
        'allowBomberMissions': json['allowBomberMissions'] == null ? undefined : json['allowBomberMissions'],
        'allowOpticMissions': json['allowOpticMissions'] == null ? undefined : json['allowOpticMissions'],
        'allowRadioMissions': json['allowRadioMissions'] == null ? undefined : json['allowRadioMissions'],
        'droneUid': json['droneUid'],
        'packetRate': json['packetRate'] == null ? undefined : json['packetRate'],
        'preferredChannels': json['preferredChannels'],
    };
}

export function OutputPilotTeamSettingsToJSON(value?: OutputPilotTeamSettings | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'CraftNames': value['craftNames'],
        'allowBomberMissions': value['allowBomberMissions'],
        'allowOpticMissions': value['allowOpticMissions'],
        'allowRadioMissions': value['allowRadioMissions'],
        'droneUid': value['droneUid'],
        'packetRate': value['packetRate'],
        'preferredChannels': value['preferredChannels'],
    };
}

